<script setup lang="ts">
// Store
import { useUserStore } from '~/store/userStore';
import { useTocStore } from '~/store/tocStore';
// Composables
import { useSidebarRoutes } from '~/composables/useSidebarRoutes';

const userStore = useUserStore();
const tocStore = useTocStore();
const route = useRoute();
const router = useRouter();
const { getSidebarRoutes } = useSidebarRoutes();

const userPermission = computed(() => userStore.userRoutePermission);

const getEquipList = await tocStore.getDesignTocSiteList({
  pageNo: 1,
  pageSize: 100
}); 

const originData = computed(() => {
  // 동적으로 생성된 사이드바 라우트 사용
  // 사용자 정보와 권한이 변경될 때마다 재계산
  const userAuthGroup = userStore.loginUserInfo?.authGroupSeq;
  const userRoutePermission = userStore.userRoutePermission;
  
  const routes = getSidebarRoutes.value;
  console.log('Sidebar Routes:', routes);
  console.log('User Auth Group:', userAuthGroup);
  console.log('User Route Permission:', userRoutePermission);
  
  return routes;
})


const sideBarRouteList = computed(() => {
  let tocRouterList = JSON.parse(JSON.stringify(originData.value));

  tocRouterList?.forEach((route: any) => {
    // icon 경로를 실제 파일 경로로 변환
    if (route.icon) route.icon = getIconPath(route.icon);
  })

  return tocRouterList;
});

// ANCHOR: router config에 있는 icon 이름을 실제 파일 경로로 변환
function getIconPath(iconName: string): string {
  return `/assets/images/renewal/${iconName}.svg` || `/assets/images/renewal/dashboard_icon.svg`; // default icon
}

const loginUserInfo = computed(() => userStore.loginUserInfo);

// ANCHOR: 열린 메뉴 상태 추적
const openMenus = ref<Set<number>>(new Set());

// ANCHOR: 컴포넌트 마운트 시 current-show 클래스가 있는 서브메뉴 초기화
onMounted(() => {
  // current-show 클래스가 있는 모든 서브메뉴를 auto 높이로 설정
  const currentShowMenus = document.querySelectorAll('.sub-menu.current-show');
  currentShowMenus.forEach(menu => {
    const element = menu as HTMLElement;
    element.style.height = 'auto';
  });
  
  // 기존에 열려있던 메뉴들 복원
  restoreOpenMenus();
});

// ANCHOR: 현재 경로에 해당하는 서브메뉴 찾기
function findCurrentSubMenuIndex(): number | null {
  for (let i = 0; i < sideBarRouteList.value.length; i++) {
    const routeItem = sideBarRouteList.value[i];
    if (route.path.includes(routeItem.path)) {
      // 자식 라우트 중에서도 현재 경로와 일치하는지 확인
      if (routeItem.children) {
        for (const child of routeItem.children) {
          if (route.path.includes(`/design-toc/${routeItem.path}/${child.path}`)) {
            return i;
          }
        }
      }
      return i;
    }
  }
  return null;
}

// ANCHOR: 열린 메뉴 상태 복원 및 current-show 클래스 업데이트
function restoreOpenMenus() {
  const currentMenuIndex = findCurrentSubMenuIndex();
  
  // NOTE: 모든 서브메뉴에서 current-show 클래스 제거 및 상태 정리
  const allSubMenus = document.querySelectorAll('.sub-menu');
  allSubMenus.forEach((menu, index) => {
    const menuElement = menu as HTMLElement;
    menuElement.classList.remove('current-show');
    
    // NOTE: 현재 메뉴가 아니면 닫기 (show 클래스 제거, 높이 0)
    if (index !== currentMenuIndex) {
      menuElement.classList.remove('show');
      menuElement.style.height = '0';
    }
  });
  
  // NOTE: 현재 경로에 해당하는 서브메뉴에 current-show 클래스 추가
  if (currentMenuIndex !== null) {
    const currentSubMenu = document.getElementById(`subMenu${currentMenuIndex}`) as HTMLElement;
    if (currentSubMenu) {
      currentSubMenu.classList.add('current-show');
      currentSubMenu.style.height = 'auto';
    }
    
    // NOTE: openMenus에서도 현재 메뉴 제거 (current-show는 별도 관리)
    openMenus.value.delete(currentMenuIndex);
  }
  
  // NOTE: 기존에 열려있던 다른 메뉴만 복원
  openMenus.value.forEach(menuIndex => {
    if (menuIndex !== currentMenuIndex) {
      const subMenu = document.getElementById(`subMenu${menuIndex}`) as HTMLElement;
      if (subMenu) {
        subMenu.classList.add('show');
        subMenu.style.height = 'auto';
      }
    }
  });
}

// ANCHOR: 라우트 변경 감지하여 메뉴 상태 복원
watch(() => route.path, () => {
  nextTick(() => {
    restoreOpenMenus();
  });
});


function checkHover(e: Event, i: number){
  if(e.target instanceof HTMLElement && e.target.tagName === 'BUTTON'){

    openSubMenu(i)
  }
}

function test(a: any){
  console.log(a);
  // router.push('./')
}

function openSubMenu(idx: number){
  const subMenu = document.getElementById(`subMenu${idx}`) as HTMLElement;
  subMenu.style.display = 'block';
}

function closeSubMemu(idx: number){
  const subMenu = document.getElementById(`subMenu${idx}`) as HTMLElement;
  subMenu.style.display = 'none';
}

function goRouter($event:any, mainRoute:any, subRoute: any){
  if (mainRoute.path === 'dashboard' && subRoute.path !== 'default') {
    if (userPermission.value === 'equipone'){

      router.push({
        name: subRoute.name,
        params: {
          equipid: tocStore.selectEquipInfo.cid
        }
      });
    } else if (userPermission.value === 'siteone') {
      router.push(`/toc/dashboard/sites/default`);
    } else {
      router.push(`/toc/${mainRoute.path}/${subRoute.path}`);
    }
  } else {
    router.push(`/toc/${mainRoute.path}/${subRoute.path}`);
  }
}

// ANCHOR: 서브메뉴 토글
function toggleSubMenu(idx: number){
  const subMenu = document.getElementById(`subMenu${idx}`) as HTMLElement;
  
  // NOTE: current-show가 있으면 토글 이벤트 제외 (현재 경로)
  if (subMenu.classList.contains('current-show')) {
    return;
  }
  
  // NOTE: 닫기
  if (subMenu.classList.contains('show')) {
    const currentHeight = subMenu.scrollHeight;

    animateHeight(subMenu, currentHeight, 0, () => {
      subMenu.classList.remove('show');
      subMenu.style.height = '';
    });
    
    // 열린 메뉴 목록에서 제거
    openMenus.value.delete(idx);
  } 
  // NOTE: 열기
  else {
    subMenu.style.height = '0px';
    subMenu.classList.add('show');
    
    subMenu.offsetHeight;
    
    const targetHeight = subMenu.scrollHeight;
    animateHeight(subMenu, 0, targetHeight, () => {
      subMenu.style.height = 'auto';
    });
    
    // 열린 메뉴 목록에 추가
    openMenus.value.add(idx);
  }
}

// ANCHOR: Height 애니메이션
function animateHeight(element: HTMLElement, startHeight: number, endHeight: number, callback?: () => void) {
  const duration = 300;
  const startTime = performance.now();
  
  function animate(currentTime: number) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    
    const easedProgress = 1 - Math.pow(1 - progress, 3);
    
    const currentHeight = startHeight + (endHeight - startHeight) * easedProgress;
    element.style.height = Math.round(currentHeight) + 'px';
    
    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      if (callback) callback();
    }
  }
  
  requestAnimationFrame(animate);
}



function checkMenuRoute(menuRoute: any): boolean {
  let result = false;

  // 현재 라우트와 메뉴 라우트가 정확히 일치하는지 확인
  if(menuRoute.name === route.name){
    result = true;
    return result;
  }

  // 자식 메뉴가 있는 경우 재귀적으로 확인
  if (menuRoute.children) {
    for (let i = 0; i < menuRoute.children.length; i++) {
      let child = menuRoute.children[i];
      
      // 자식 메뉴가 현재 라우트와 일치하는지 확인
      if(child.name === route.name){
        result = true;
        break;
      } 
      // 자식 메뉴에도 자식이 있는 경우 재귀 호출
      else if(child.children){
        result = checkMenuRoute(child);
        if(result) break; // 일치하는 메뉴를 찾으면 루프 종료
      }
    }
  } 

  return result;
}

</script>

<template>
  <div class="toc-design-sidebar">
    <div class="menu">
      <!-- route path가 같을 때 클래스 추가 (포함X) -->
      <!-- <div 
        v-for="(inRoute, i) in sideBarRouteList"
        class="btn-wrapper"
        :class="route.path.includes(inRoute.path) ? 'select' : ''"
      > -->
      <template v-for="(inRoute, i) in sideBarRouteList">
      <div 
        v-if="inRoute.hidden === false || inRoute.hidden === undefined"
        class="btn-wrapper"
        :class="checkMenuRoute(inRoute) ? 'select' : ''"
      >
        <button class="btn" @click="toggleSubMenu(i)">
          <img class="icon" :src="inRoute.icon" />
          <span>{{ inRoute.meta.name }}</span>
        </button>

        <div 
          :id="`subMenu${i}`" 
          class="sub-menu" 
          :class="route.path.includes(inRoute.path) ? 'current-show' : ''"
        >
        <template
        v-for="(sub, j) in inRoute.children"
        >
          <!-- <button
            v-if="sub.hidden === false"
            class="btn" 
            :class="route.path.includes(`/toc/${inRoute.path}/${sub.path}`) ? 'select' : ''"
            @click="goRouter($event, inRoute, sub)"
          > -->

          <button
            v-if="sub.hidden === false"
            class="btn" 
            :class="checkMenuRoute(sub) ? 'select' : ''"
            @click="goRouter($event, inRoute, sub)"
          >
            {{ sub.meta.name }}
          </button>
        </template>
        </div>
      </div>
     </template>

    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/design-toc/define_font.scss';
@use '@/assets/styles/design-toc/toc-design-sidebar.scss';

.btn-wrapper {
  & img {
    width: 25px;
    height: 25px;
  }

  & .sub-menu {
    // TODO: 추 후, 토글 기능을 사용하지 않을 경우 삭제.
    height: 0;
    overflow: hidden;

    &.show,
    &.current-show {
      height: auto;
    }

    & .btn {
      @include define_font.text-normal-14;
      padding: 6px 10px !important;
    }
  }
}
</style>